module.exports = __webpack_public_path__ + "static/media/25_CORTINAO_SEM_BOJO_LISO_01.8dda2768.jpg";